

















































































import { computed, defineComponent } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import useVaultView from "@/hooks/useVaultView";
import { isFile } from "@/lib/fileHelpers";
import { AttachmentFile, InputAttachmentFile } from "@/types";
import AttachmentFilesPreview from "@/components/AttachmentFilesPreview";
import AttachmentPriceSetting from "@/components/AttachmentPriceSetting";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import BaseSpinner from "@/components/BaseSpinner";
import SendMessageController from "@/components/SendMessageController";
import VaultModal from "@/components/VaultModal";

export default defineComponent({
  name: "MessageEditorView",
  components: {
    BaseInputTextarea,
    BaseInputFile,
    BaseSpinner,
    BaseIcon,
    AttachmentFilesPreview,
    SendMessageController,
    AttachmentPriceSetting,
    VaultModal,
  },
  props: {
    files: { type: Array as () => AttachmentFile[], required: true },
    packageList: { type: Array as () => PaymentPackage[], required: true },
    attachmentPriceId: { type: String, required: true },
    uploadingAttachment: { type: Boolean, default: false },
    switcherTitle: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    value: { type: String, default: "" },
    isShowEditor: { type: Boolean, default: true },
    loading: { type: Boolean, required: true },
    allowedPublicFilesCount: { type: Number, default: 0 },
    allowedPrivateFilesCount: { type: Number, default: 1 },
  },
  setup(props, { emit }) {
    const isNoPrice = computed(() => props.attachmentPriceId === "0");
    const isShowPriceSetting = computed(() => props.packageList.length > 0 && props.files.length > 0);

    const isUploadingAvailable = (access: boolean = false) => {
      return (
        !props.uploadingAttachment &&
        ((access && props.allowedPublicFilesCount !== 0) || (!access && props.allowedPrivateFilesCount !== 0))
      );
    };
    const { showPrivateVault, showPublicVault, showVaultOrNative } = useVaultView();
    const onAddFiles = (showNativeUploader: () => void, publicAccess: boolean): void => {
      if (isUploadingAvailable(publicAccess)) {
        showVaultOrNative(showNativeUploader, publicAccess);
      }
    };
    const addAttachment = (files: (AttachmentFile | File)[], publicAccess: boolean) => {
      const fileList: (InputAttachmentFile | AttachmentFile)[] = files.map(file => {
        if (isFile(file)) {
          return { file, publicAccess };
        }
        file.publicAccess = publicAccess;
        return file;
      });
      fileList.length > 0 && emit("addAttachment", fileList);
    };

    return {
      showPrivateVault,
      showPublicVault,
      isShowPriceSetting,
      isNoPrice,
      onAddFiles,
      addAttachment,
    };
  },
});
